import { Form as AntForm } from "antd";

export const useCustomWatch: typeof AntForm.useWatch = (
  ...args: Parameters<typeof AntForm.useWatch>
) => {
  const [fieldPath, formOrOptions] = args;

  let finalFieldPath = fieldPath;

  if (typeof fieldPath === "string" && fieldPath.includes(".")) {
    finalFieldPath = fieldPath.split(".");
  }

  return AntForm.useWatch(finalFieldPath, formOrOptions);
};
